import { TableCell, TableRow } from "@/shared/components/ui/table";
import { RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { Spinner } from "./spinner";

export function TableLoadingRow({ colSpan }: { colSpan: number }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <div className="flex w-full items-center justify-center gap-2">
          <Spinner />
          <span>{t("Lade Daten")}</span>
        </div>
      </TableCell>
    </TableRow>
  );
}
